import { Box, Button, Card, CardContent, FormControl, Grid, InputLabel, MenuItem, Modal, Select } from "@mui/material";
import { useEffect, useState } from "react";
import { IUser } from './IUser'
import { approveUsersAsync, selectUsers, updateUserRolesAsync } from './adminSlice'
import { useAppSelector, useAppDispatch } from '../../app/hooks'
import uuid from "react-uuid";
import { wrapArgument } from "../../lib/api-status/actionWrapper";
import { useNavigate } from 'react-router-dom';
import { hasCheckerAndUserAdmin } from '../../lib/workflowStatus';


const RoleComponent = (props: any) => {

    const [actionUid] = useState(uuid())
    const dispatch = useAppDispatch()
    const usersState = useAppSelector(selectUsers)
    const navigate = useNavigate()
    const { userDetails } = props
    const [data, setData] = useState(userDetails || {} as IUser)
    const rawRole = String(userDetails?.role || "").toUpperCase();
    const currentRole = hasCheckerAndUserAdmin(rawRole) || rawRole.includes('MANAGER')
        ? "CHECKER,USERADMIN"
        : rawRole;
    const isRegistered = currentRole === "REGISTERED";

    // Context-aware role lists:
    // - Pending approval (REGISTERED users) → only USER (they are fund applicants)
    // - Operational users → no USER (they are staff), no DISABLED (use enable/disable buttons instead)
    const rolesForPending = ['USER'];
    const rolesForOperational = ['USERADMIN', 'CHECKER', 'MAKER', 'CHECKER,USERADMIN', 'ADMIN'];
    const roles = isRegistered ? rolesForPending : rolesForOperational;

    const [selectedRole, setSelectedRole] = useState<string>(
        isRegistered ? 'USER' : (currentRole || rolesForOperational[0])
    );

    const style = {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    const handleSelectChange = (e: any) => {
        const role = String(e.target.value);
        setSelectedRole(role);
        setData({ ...data, role })
    }

    const handleClose = () =>{
        props.handleClose();
        
    }

    function handleSubmitForm() {
        if (!selectedRole) return;
        if (!isRegistered) {
            if (!data.id) return;
            dispatch(
                updateUserRolesAsync(
                    wrapArgument(actionUid, { id: Number(data.id), role: selectedRole })
                )
            );
            return;
        }
        // Always use selectedRole (not data.role which still holds "REGISTERED")
        dispatch(
            approveUsersAsync(
                wrapArgument(actionUid, { ...data, role: selectedRole })
            )
        )
    }

    return <Modal
        open={props.open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className= "special_modal2"
    >

        <Box sx={style}>
            <Box sx={{ backgroundColor: 'white', borderRadius: 1, }}>
                {/* <Card sx={{ display: 'flex',  background: '#f2f2f2'}}>

                    <CardContent sx={{ flex: 1 }}> */}
                        <Grid container spacing={2} >
                            <Grid item xs={3}>
                                <FormControl size="medium" fullWidth>
                                    <InputLabel id="demo-select-small">Assign Role</InputLabel>
                                    <Select
                                        labelId="demo-select-small"
                                        id="demo-select-small"
                                        label="Assign Role"
                                        value={selectedRole}
                                        onChange={handleSelectChange}
                                    >
                                        {roles.map((role) => (
                                            <MenuItem key={role} value={role}>{role === "CHECKER,USERADMIN" ? "CHECKER + USERADMIN" : role}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <Box sx={{ mt: 2 }}>
                                    <Button onClick={handleSubmitForm} color='success' variant="contained" disableElevation sx={{ textTransform: 'none' }} >
                                        Submit
                                    </Button>
                                </Box>
                                
                            </Grid>
                            <Grid item xs={6}>
                                <Box sx={{ mt: 2 }}>
                                    {usersState.response != undefined ? <>{usersState.response}</> : <></>}
                                </Box>
                            </Grid>
                        </Grid>

                    {/* </CardContent>
                </Card> */}
            </Box>
        </Box>
    </Modal >

}

export default RoleComponent;